import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=1b7ff211&scoped=true&"
import script from "./PagePreview.vue?vue&type=script&lang=js&"
export * from "./PagePreview.vue?vue&type=script&lang=js&"
import style0 from "./PagePreview.vue?vue&type=style&index=0&id=1b7ff211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ff211",
  null
  
)

export default component.exports